module.exports = __webpack_public_path__ + "static/media/trn-swear.90560a80.png";